import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  mediaPreview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%'
    },
    '& video': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  }
})

export default useStyles
